import { CommonModule } from '@angular/common';
import { Component, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { ClientDataStoreService } from '@app/services/client-data-store.service';
import { ClientSelectDropdown, ClientTree } from '../client-select-dropdown';
import { filter } from 'rxjs';

@Component({
  selector: 'app-client-select-dropdown-desktop',
  standalone: true,
  imports: [
    CommonModule
  ],
  providers: [],
  templateUrl: './client-select-dropdown-desktop.component.html',
  styleUrl: './client-select-dropdown-desktop.component.scss'
})
export class ClientSelectDropdownDesktopComponent extends ClientSelectDropdown implements OnDestroy {

  constructor(clientStore: ClientDataStoreService, router: Router) {
    super(clientStore, router);

    this.subscriptions$.push(
      clientStore.clientTree$
      .pipe(filter(client => !!client))
      .subscribe(client => {
        client.Expanded = true;
        
        this.mainClient = client;
        this.syncSelectedClient();
      }),
      clientStore.clientSummary$.subscribe(clientSummary => {
        this.syncSelectedClient(clientSummary?.ClientId);
      })
    );
  }

  onClientClicked(client: ClientTree) {
    if (client.Id === this.selectedClient.Id) {
      this.toggleDropdown();
      
      return;
    }

    if (this.isInsightsRoute) {
      this.selectClient(client);
      this.toggleDropdown();

      return;
    }

    if (client.Id === this.mainClient.Id) {
      this.toggleDropdown();

      return;
    }
    
    if (client.Clients.length > 0) {
      this.toggleClientChildren(client);
      return;
    }
    
    this.selectClient(client);
    this.toggleDropdown();
  }

  toggleDropdown() {
    this.clientDropdownExpanded = !this.clientDropdownExpanded;
  }

  ngOnDestroy(): void {
    this.subscriptions$.forEach(s => s.unsubscribe());
  }
}
